export default __webpack_public_path__ + "static/media/ico-postgress-score-moderate.08bf0d29.svg";